import React, { useState,useEffect,useReducer  } from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";   
  
import CommonAPI from '../../Common/CommonAPI';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import SuccessMSG from "../../Common/SuccessMsg"
import FadeLoader from "react-spinners/HashLoader";
import OTPModal from "../../Common/OTP"
import DownloadPDF from "../../Common/DownloadPDF"


function  StandingOrder (props) {  
   
    const [validator,setValidator] = useState(new SimpleReactValidator());
    const [validator2,setValidator2] = useState(new SimpleReactValidator());
    const [SaveBeneOptn, setSaveBeneOptn] = useState(false);
    const [newAccount, setNewAccount] = useState();
    const [FromAccountList, setFromAccountList] = useState([]);
    const [ExistAccountList, setExistAccountList] = useState([]);
    const [SelectFromAccount, setSelectFromAccount] = useState();
    const [SelectFromAccountID, setSelectFromAccountID] = useState();
    const [FromAccountAvailableBalance, setFromAccountAvailableBalance] = useState();
    const [EnteredAmount,setEnteredAmount] = useState();
    const [YourRef,setYourRef] = useState();
    const [BeneRef,setBeneRef] = useState();
    const [SelectDate,setSelectDate] = useState(new Date());
    const [SelectToAccount,setSelectToAccount] = useState();
    const [SelectToAccountID,setSelectToAccountID] = useState();
    const [SelectToAll,setSelectToAll] =useState({});
    const [SelectFromAll,setSelectFromAll] =useState({});
    const [SelectBankAll,setSelectBankAll] =useState({});
    const [SelectBranchAll,setSelectBranchAll] =useState({});
    const [HolderName,setHolderName] = useState();
    const [SavAccId,setSavAccId] = useState();
    const [BankList,setBankList] = useState([]);
    const [NewPayeeSelectedBranchID,setNewPayeeSelectedBranchID] = useState();
    const [SenkAccountValidate,setSenkAccountValidate] = useState();
    const [BranchList,setBranchList] = useState([]);
    const [NewPayeeSelectBank,setNewPayeeSelectBank]  = useState("select");
    const [NewBankId,setNewBankId] = useState();
    const [NewPayeeName,setNewPayeeName] = useState();
    const [NewPayeeSelectedBranch,setNewPayeeSelectedBranch] = useState();
    const [NewPayeeSelectedBranchCode,setNewPayeeSelectedBranchCode] = useState();
    const [NewPayeeAccountNum,setNewPayeeAccountNum] = useState();
    const [NewPayeeEnteredAmount, setNewPayeeEnteredAmount]  = useState();
    const [NewPayeeYouRef, setNewPayeeYouRef]  = useState();
    const [NewPayeeBeneRef, setNewPayeeBeneRef]  = useState();
    const [Email,setEmail]  = useState();
    const [Mobile,setMobile]  = useState();
    const [ShowReview,setShowReview]  = useState(false);
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [ErrorMsg, setErrorMsg] = useState();
    const [OtpReference, setOtpReference] = useState();
    const [ExistBankId, setExistBankId] = useState();
    const [ExistBranchId, setExistBranchId] = useState();
    const [ExistBeneMobile, setExistBeneMobile] = useState();
    const [ExistBeneEmail, setExistBeneEmail] = useState();
    const [ExistBankName, setExistBankName] = useState();
    const [ExistBranchName, setExistBranchName] = useState();
    const [ExistPayeeId, setExistPayeeId] = useState("");
    const [ExistBeneRef, setExistBeneRef] = useState();
    const [ExistYourRef, setExistYourRef] = useState();
    const [CountryCodeList, setCountryCodeList] = useState([]);
    const [ExistTeleCode, setExistTeleCode] = useState(94);
    const [ExistTeleCountry, setExistTeleCountry] = useState();
    const [Password, setPassword] = useState();
    const [ErrorPassword, setErrorPassword] = useState();
    const [NewPayeeOptn,setNewPayeeOptn] = useState();
    const [ReviewError,setReviewError] = useState();
    const [SaveRecord,setSaveRecord] = useState(false);
    const [BranchValid,setBranchValid] = useState();
    const [SenkAccValidate,setSenkAccValidate] = useState(false);
    const [CheckRealTime,setCheckRealTime] = useState("R");
    const [NewPayeeID,setNewPayeeID] = useState("");
    const [ConfirmOTPLoading,setConfirmOTPLoading] = useState(false);
    const [ConfirmOTP,setConfirmOTP] = useState(false);
    const [ConfirmTransferMsg,setConfirmTransferMsg] = useState(false);
    const [ReferenceNum,setReferenceNum] = useState();
    const [UnsuccessMessage,setUnsuccessMessage] = useState();
    const [RejectReview,setRejectReview] = useState(false);
    const [CeftMessage,setCeftMessage] = useState("");
    const [SuccessLoading,setSuccessLoading] = useState(false);
    const [EnteredOTP,setEnteredOTP] = useState();
    const [NewStandFrequency,setNewStandFrequency] = useState("");
    const [StartDate,setStartDate] = useState(new Date());
    const [EndDate,setEndDate] = useState(new Date());
    const [Recurring,setRecurring] = useState();
    const [ExistBeneAdd1,setExistBeneAdd1] = useState("");
    const [ExistBeneAdd2,setExistBeneAdd2] = useState("");
    const [STOSuccess,setSTOSuccess] = useState(false);
    const [ PdfDownload,setPdfDownload] =useState(false);
    const [ SuccessUnsuccessStatus,setSuccessUnsuccessStatus] =useState();
    const [btnDisable,setbtnDisable] = useState(false);
    const [btnDisable2,setbtnDisable2] = useState(false);
     
    var EmailValidate = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const GetAccountsAPI = () =>{
        CommonAPI.FromToAccountAPI((results) =>{   
            if( results){                    
              setFromAccountList(results.data.mapAccountList?results.data.mapAccountList.filter(e=>(e.fromOrToAccount===1 && e.showByAccOpt)):null);                            
            }
        });
      }
    
      const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }
    
      const GetExistPayeeAPI = () =>{
        CommonAPI.GetExistSTORecipeientsAPI((results) =>{   
            if( results){                    
              setExistAccountList(results?results:null);                     
            }
        });
      }
    
    const GetBankListAPI = () =>{
        CommonAPI.FetchBankList((results) =>{   
            if( results){                    
                setBankList(results);                              
            }
        });
      }
    const GetCountryCodeAPI = () =>{
        CommonAPI.GetCountryCode((results) =>{   
            if( results){                    
                setCountryCodeList(results);                              
            }
        });
      }
    
      useEffect( () => {    
      GetAccountsAPI();
      GetBankListAPI();
      GetExistPayeeAPI();
      GetCountryCodeAPI();  
      },[]) ;

      const SelectFromOnChange = (event) => {

        var passValFrom = JSON.parse(event.target.value);
        setSelectFromAll(JSON.parse(event.target.value));
        setSelectFromAccount(passValFrom.accountNo?passValFrom.accountNo:null);
        setSelectFromAccountID(passValFrom.id?passValFrom.id:null);
        setFromAccountAvailableBalance(passValFrom.avialableBalance?passValFrom.avialableBalance:null);         
     }
    
    const SelectToOnChange = (event) => {
        var passValTo = JSON.parse(event.target.value);
        setNewAccount( passValTo ==="new"?JSON.parse(event.target.value):"")    
        setSelectToAll(JSON.parse(event.target.value));
        setSelectToAccount(passValTo ==="new"?"new":passValTo.bankAccNo);       
        setExistBeneAdd1(passValTo.beneAdd1);
        setExistBeneAdd2(passValTo.beneAdd2);
        setSelectToAccountID(passValTo.id);
        setHolderName(passValTo.beneName);
        setSavAccId(passValTo.savAccId);   
        setExistBankId(passValTo.beneBankId);
        setExistBranchId(passValTo.bankBrId);
        setExistBeneMobile(passValTo.benePhone?passValTo.benePhone:"",);
        setExistBeneEmail(passValTo.beneEmail?passValTo.beneEmail:"");
        setExistBankName(passValTo.beneBankName);
        setExistBranchName(passValTo.beneBrachName);
        setExistPayeeId (passValTo.id);
        setExistBeneRef (passValTo.beneReference?passValTo.beneReference:"");
        setExistYourRef (passValTo.reference?passValTo.reference:"");    
      }
    
    const SelectBankList = (event) => {
    
        var passValFrom = JSON.parse(event.target.value);
        if(passValFrom.id===37){
            setNewPayeeSelectedBranchID("001")
            forceUpdate()
        }else{
             setSenkAccountValidate(false);
             setNewPayeeSelectedBranchID();
            };       
    
        setBranchList([]);
        setNewPayeeSelectedBranch("");
        setExistBranchName("");
        setSelectBranchAll("");
        setSelectBankAll(JSON.parse(event.target.value));
        setNewBankId(passValFrom.id);
        setNewPayeeSelectBank(passValFrom.name);
       
        if(passValFrom.id){
            CommonAPI.FetchBranchList({bid: passValFrom.id},(results) =>{   
                if( results){                    
                    setBranchList(results);                              
                }
            });      
          }
       }
    
    const  SelectedBranch = (event) => {
        setBranchValid();
        var passValFrom = JSON.parse(event.target.value);  
          setSelectBranchAll(JSON.parse(event.target.value));  
          setNewPayeeSelectedBranch(passValFrom.name);
          setNewPayeeSelectedBranchCode( passValFrom.code);
          setNewPayeeSelectedBranchID(passValFrom.id);  
        }

    const CheckSenkadagalaAccounts = () =>{
         CommonAPI.CheckSenkadagalaAccounts({NewPayeeAccountNum:NewPayeeAccountNum},(results)=>{
            if(results.senkAccount==="YES"){                
                setNewPayeeAccountNum(results.accountNo);
                setSenkAccValidate(false);                  
            }else{
                setSenkAccValidate(true);                 
            }
                return results;
            });
    }

        const ValidateFields = () =>{
            var FormatedDate = '';    
            FormatedDate = moment(StartDate).format('DD/MM/YYYY');
            if (!validator.allValid()) {
                validator.showMessages();
                // rerender to show messages for the first time
                // you can use the autoForceUpdate option to do this automatically`            
                   forceUpdate();    
            }else if(newAccount==="new"&&!validator2.allValid()){
                validator.showMessages();
                validator2.showMessages();
                forceUpdate();
              }else if( NewPayeeEnteredAmount <= 0){
                setErrorMsg("Amount must be greater than 0")
              }else if((FormatedDate == moment(new Date()).format('DD/MM/YYYY')) && NewPayeeEnteredAmount>=(FromAccountAvailableBalance-100)){
                setErrorMsg("Insufficient balance");
              }else{
                setErrorMsg("");
                setErrorPassword();
                setReviewError();
                CommonAPI.FetchOTPReference((results) =>{   
                    if( results){                    
                        setOtpReference(results);    
                        console.log(results) ;                         
                    }
                });
                setShowReview(true);
              }
          }


          const ReviewModal = ()=>{
        
            return (
                 <Modal
                   show={ShowReview}
                   size="md"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered 
                   backdrop="static"
                   onHide = {()=>setShowReview(false)}
                 >
                   <Modal.Header closeButton>
                     <Modal.Title  id="contained-modal-title-vcenter">
                       <p className='modal-head-f'>PAYMENT</p><br/>REVIEW
                     </Modal.Title>
                   </Modal.Header>
                   <Modal.Body>
                     
                     <Form >
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                                 From
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column >
                                 {SelectFromAccount}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         <div>
                         <Form.Label className="c-font fontSize t-center " column sm={12}>
                                 PAYEE DETAILS
                        </Form.Label>
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                                 Name
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column>
                             {HolderName?HolderName:NewPayeeName}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                                Bank
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column>
                             {ExistBankName?ExistBankName:NewPayeeSelectBank}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         {NewBankId!==37?
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                                Branch
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column>
                             {ExistBranchName?ExistBranchName:NewPayeeSelectedBranch}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>:null
                         }{NewBankId!==37&&newAccount==="new"?
                            <Form.Group as={Row} className="mb-1 margintop-f">
                                <Form.Label className="c-font" column sm={5} xs={5}>
                                   Branch Code
                                </Form.Label>
                                <Col sm={7} xs={7}>
                                <Form.Label className="c-font " column>
                                {NewPayeeSelectedBranchCode}
                                </Form.Label>                        
                                </Col>
                            </Form.Group>:null
                        }
                         
                         </div>
                         <Form.Group as={Row} className="mb-1 margintop-f" >
                             <Form.Label className="c-font" column sm={5} xs={5}>
                                 Account Number
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column>
                                 {newAccount==="new"?NewPayeeAccountNum:SelectToAccount}
                             </Form.Label>  
                             </Col>
                         </Form.Group>
                         
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                                 Amount
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column>
                                 {parseFloat(NewPayeeEnteredAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                             </Form.Label>                        
                             </Col>
                         </Form.Group> 
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                              Your Reference
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column>
                                 {ExistYourRef?ExistYourRef:NewPayeeYouRef}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                              Beneficiary Reference
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column >
                                 {ExistBeneRef?ExistBeneRef:NewPayeeBeneRef}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                             Start Date
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column >
                             {moment(StartDate).format("DD/MM/YYYY")}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                             Frequency
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column >
                                 {NewStandFrequency==="D"?"Daily":NewStandFrequency==="W"?"Weekly"
                                 :NewStandFrequency==="M"?"Monthly":NewStandFrequency==="Q"?"Quarterly"
                                 :NewStandFrequency==="H"?"Half Yearly":NewStandFrequency==="Y"?"Yearly":"-"}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                             End Date
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column >
                             {moment(EndDate).format("DD/MM/YYYY")}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         {newAccount==="new"?
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                             Save Beneficiary Details
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column >
                             <div className='d-flex align-items-center'>
                                <input checked={SaveBeneOptn} 
                                 onChange={()=>{setSaveBeneOptn(true)}} 
                                 type="radio" id="html" name="fav_language" value="HTML"/>
                                <label className='input-w' > Yes</label>
                                
                                <input checked={!SaveBeneOptn} onChange={()=>{setSaveBeneOptn(false)}} type="radio" id="html" name="fav_language" value="HTML"/>
                                <label className='input-w' > No </label>                                
                            </div>
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         :null
                            }
                        {newAccount==="new"?
                         <Form.Group as={Row} className="mb-1 margintop-f">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                             OTP Reference
                             </Form.Label>
                             <Col sm={7} xs={7}>
                             <Form.Label className="c-font" column >
                                 {OtpReference}
                             </Form.Label>                        
                             </Col>
                         </Form.Group>
                         :
                         null}
                         
                         
                           <Form.Group as={Row} className="mb-1 margintop-f3">
                             <Form.Label className="c-font" column sm={5} xs={5}>
                              Password
                             </Form.Label>
                             <Col sm={7} xs={7}>                         
                                <Form.Control 
                                maxLength={8}
                                value={Password}
                                onChange={(text)=>setPassword(text.target.value)}
                                className={!Password?"form-h2 password-f":"form-h2"} size="sm" type="password" placeholder="Password" />
                                <p className='vali-txt'>{ErrorPassword}</p>                                                       
                                <p className='vali-txt'>{ReviewError}</p>                                                       
                                <p className='vali-txt'>{SaveRecord}</p>                                                       
                             </Col>
                             
                         </Form.Group>
                     </Form>
                   </Modal.Body>
                 
                    <Modal.Footer>                
                    <Button className="btn-logout" 
                     disabled={btnDisable}
                     onClick={()=>{setbtnDisable(true);CheckFirstPassword()}} >
                        Confirm
                    </Button>
                   </Modal.Footer>
                    
                 </Modal>
               );         
           }
           const CheckFirstPassword = () =>{
            setSuccessLoading(true);
            setShowReview(false);
            setTimeout(()=>{
            CommonAPI.CheckPassword({password:Password},(results) =>{   
                    if(results.password==="true"){  
                        setErrorPassword("");
                        setbtnDisable(false);
                        CreateStandingOrderAPI();                           
                    }else if(results.password==="false"){ 
                        setbtnDisable(false);
                        setSuccessLoading(false);
                        setNewPayeeOptn();
                        setShowReview(true);
                        setErrorPassword("Incorrect Password");
                        setReviewError();
                    }
                })
            },100)        
        }
        const CreateStandingOrderAPI = () =>{

         var ExistPayeeFirstDate = moment(StartDate).format("YYYY-MM-DD");
         var ExistPayeeEndDate = "";
         if(Recurring==="N"){
            ExistPayeeEndDate="null"
          }else{
            ExistPayeeEndDate =moment(EndDate).format("YYYY-MM-DD")
          }
        CommonAPI.CreateStandingOrderAPI({
            isExist:newAccount==="new"?false:true,
            ExistSelectToBankBranchID:ExistBranchId?ExistBranchId:NewPayeeSelectedBranchID,
            ExistSelectFromAccountID:SelectFromAccountID,
            OtpReference:OtpReference,
            beneSave: newAccount==="new"?SaveBeneOptn:"false",
            ExistTransferOpt:Recurring,
            ExistBeneName: newAccount==="new"?NewPayeeName:HolderName,
            ExistBeneAdd1:ExistBeneAdd1,
            ExistBeneAdd2:ExistBeneAdd1,
            ExistSelectToAccount:newAccount==="new"?NewPayeeAccountNum:SelectToAccount,
            ExistPayeeFrequency:NewStandFrequency,
            ExistPayeeFirstDate:ExistPayeeFirstDate,
            ExistPayeeEndDate:ExistPayeeEndDate,
            ExistEnteredAmount:NewPayeeEnteredAmount,
            ExistBeneRef:ExistBeneRef?ExistBeneRef:NewPayeeBeneRef,
            ExistYourRef:ExistYourRef?ExistYourRef:NewPayeeYouRef,
        },(results) =>{   
            if( results.success&&newAccount==="new"){      
                setConfirmOTP(true); 
                GetAccountsAPI();
                setShowReview(false); 
                setReferenceNum(results.refNumber) 
                setSuccessUnsuccessStatus(results.status)                   
                setSuccessLoading(false);              
            }else if(results.success){
                setSTOSuccess (true) ;              
                setShowReview(false); 
                GetAccountsAPI(); 
                setReferenceNum(results.refNumber)
                setSuccessUnsuccessStatus(results.status)                
                setSuccessLoading(false);   
            }else {
                setShowReview(true);
                setSuccessLoading(false);                    
                setReviewError(results.description?results.description:"Somethin Went Wrong");
            }
        });
      }

      const resetForm = () =>{
        setSelectFromAll([]);
        setSelectToAll([]);
        setSelectFromAccount("");
        setSelectToAccount("");
        setNewBankId("")
        setNewPayeeName(""); 
        setSelectBankAll([]);
        setSelectBranchAll([]); 
        setNewPayeeAccountNum("");
        setNewPayeeEnteredAmount("");
        setExistYourRef("");
        setNewPayeeYouRef("");
        setExistBeneRef("");
        setNewPayeeBeneRef("");
        setEmail("");
        setExistBeneEmail("");
        setMobile("");
        setExistBeneMobile("");
        setNewPayeeOptn();
        setRecurring("");
        setPdfDownload(false);
      }

      const ConfirmOtpTransfer= ()=>{
        setSuccessLoading(true);
        setTimeout(()=>{
        CommonAPI.AcceptSTO({EnteredOTP:EnteredOTP},(result)=>{
            result.map((listValue,index)=>{
                if(listValue.message==='SUCCESS'){
                    setbtnDisable2(false);
                    setSuccessLoading(false);
                    setSTOSuccess (true) ;
                    setConfirmOTP(false)
                }else{
                    setSuccessLoading(false);
                    setbtnDisable2(false);                    
                    setReviewError(listValue.otherInformation.description?listValue.otherInformation.description:"");
                    setCeftMessage(listValue.otherInformation.description?listValue.otherInformation.description:"");
                }
                })
            })
        },100)
        
    }

    const ResendOTP = () =>{
        CommonAPI.ResendOTP({OtpReference:OtpReference},(results)=>{
            if(results){
                OtpReference(results.otpRef)
            }
        });
    }
    const callToPDF = () =>{
        setSTOSuccess(false)        
        setPdfDownload(true);
      }
      var C_Name = JSON.parse(sessionStorage.getItem("NIC"));
        if(ShowReview){
            return ( <div>{ReviewModal()}</div> );
        }else if(SuccessLoading){
            return ( <div>{ResponseLoadingModal()}</div> );
        }else if(STOSuccess){
            return ( 
            <div>
                <SuccessMSG ConfirmSuccess={STOSuccess} onHide={()=>setSTOSuccess(false)} 
                Close={callToPDF} head="STANDING ORDER" head2="SUCCESS" 
                contentline1="Standing Order Completed Successfully"
                contentline2={SuccessUnsuccessStatus==="LESS_BALANCE_ADDED_SUCCESS"?"(Less Balance Added Success)":SuccessUnsuccessStatus==="SUCCESSFULLY_ADDED_FOR_FUTURE_DATE"?"(Successfully Added For Future Date)":SuccessUnsuccessStatus==="SUCCESS"?"":SuccessUnsuccessStatus}
                />
            </div> );
        }else if(ConfirmOTP){
            return ( 
            <div>
                <OTPModal ConfirmOTP={ConfirmOTP} setConfirmOTP={()=>setConfirmOTP(false)} 
                EnteredValue={(e)=>{setEnteredOTP(e.target.value)}}
                confirmdisabled={btnDisable2}
                 Confirm={()=>{setbtnDisable2(true);ConfirmOtpTransfer()}}
                FailMsg={CeftMessage} ResendOTP={ResendOTP} />
            </div> );
        }else if(PdfDownload){
            return(
              <DownloadPDF show={PdfDownload} onHide={resetForm} 
              senderAccount={SelectFromAccount}  paydate={moment(new Date()).format('DD/MM/YYYY')}
              senderName={C_Name.title+" "+C_Name.UserFirstname+" "+C_Name.UserLastname}              
              beneName={HolderName?HolderName:NewPayeeName}
              refNum={ReferenceNum} bank={ExistBankName?ExistBankName:NewPayeeSelectBank} branch={NewBankId!==37?ExistBranchName?ExistBranchName:NewPayeeSelectedBranch:"Colombo"}
              beneAccount={SelectToAccount} amount={NewPayeeEnteredAmount} 
              bankRef={ExistBeneRef?ExistBeneRef:NewPayeeBeneRef}
              dueDate={moment(new Date()).format('DD/MM/YYYY')}
              type={"Standing Order"}
              startDate={moment(StartDate).format("DD/MM/YYYY")}
              frequency={NewStandFrequency==="D"?"Daily":NewStandFrequency==="W"?"Weekly"
              :NewStandFrequency==="M"?"Monthly":NewStandFrequency==="Q"?"Quarterly"
              :NewStandFrequency==="H"?"Half Yearly":NewStandFrequency==="Y"?"Yearly":"-"}
              endDate={Recurring === 'R'?moment(EndDate).format("DD/MM/YYYY"):'Until Further Notice'}
              >
            <div className='d-flex flex-row s-top'>
                <p className=' form-h2 t-width1'>Start Date</p>
                <p className='t-width2 form-h2'>
                {moment(StartDate).format("DD/MM/YYYY")}
                </p>
            </div> 
            <div className='d-flex flex-row s-top'>
                <p className=' form-h2 t-width1'>Frequency</p>
                <p className='t-width2 form-h2'>
                {NewStandFrequency==="D"?"Daily":NewStandFrequency==="W"?"Weekly"
                :NewStandFrequency==="M"?"Monthly":NewStandFrequency==="Q"?"Quarterly"
                :NewStandFrequency==="H"?"Half Yearly":NewStandFrequency==="Y"?"Yearly":"-"}
                </p>
            </div> 
            <div className='d-flex flex-row s-top'>
                <p className=' form-h2 t-width1'>End Date</p>
                <p className='t-width2 form-h2'>
                {Recurring === 'R'?moment(EndDate).format("DD/MM/YYYY"):'Until Further Notice'}
                </p>
            </div> 
              </DownloadPDF>
            )
          }
        return (

            <Modal
              show={props.isOpen}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title  id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>STANDING</p><br/>ORDERS
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={4}>
                            *From
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select size="sm"
                         value={JSON.stringify(SelectFromAll)} 
                        onChange={SelectFromOnChange}
                        className="form-h2 ">
                            <option value={JSON.stringify("select")}>Select</option>
                            {FromAccountList?FromAccountList.filter((e)=>e.jointAccountVisibility===true).map((listValue,index)=>{
                                 return (
                                 <option  key={index} value={JSON.stringify(listValue)}>
                                   A / N : {listValue.accountNo} | Balance : LKR {parseFloat(listValue.avialableBalance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                  </option>)
                              }):
                              null
                              }
                        </Form.Select>
                        <p className='vali-txt'>{validator.message('Account', SelectFromAccount, 'required')}</p>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1 margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                            *To
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select 
                         value={JSON.stringify(SelectToAll)} 
                        onChange={SelectToOnChange} 
                        size="sm" className="form-h2 ">
                            <option value={JSON.stringify("select")}>Select</option>
                            <option value={JSON.stringify("new")}>New Account</option>
                            {ExistAccountList?ExistAccountList.map((listValue,index)=>{
                                 return (
                                 <option  key={index} value={JSON.stringify(listValue)}>
                                   A / N : {listValue.bankAccNo}  | Bank : {listValue.beneBankName} | Name : {listValue.beneName}
                                  </option>)
                              }):
                              null
                              }   
                        </Form.Select> 
                        <p className='vali-txt'>{validator.message('Account', SelectToAccount, 'required')}</p>
                        </Col>
                    </Form.Group>
                    {newAccount==="new"?
                    <div>
                    <Form.Group as={Row} className="mb-1 margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                           *Name
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Control 
                            value={NewPayeeName}
                            onChange={(text)=>setNewPayeeName(text.target.value )} 
                            className="form-h2" size="sm" 
                            type="text" placeholder="Name" />
                        </Col>
                        <p className='vali-txt'>{validator2.message('Name', NewPayeeName, 'required')}</p>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1 margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                            *Bank
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select                              
                            value={JSON.stringify(SelectBankAll)}
                            onChange={SelectBankList} 
                            size="sm" className="form-h2 ">
                                <option  value={JSON.stringify("select")}>Select</option>
                            { BankList.map((listValue,index)=>{
                                return (<option value={JSON.stringify(listValue)}>{listValue.name}</option>)
                                })
                            }
                            </Form.Select>
                            <p className='vali-txt'>{validator2.message('Bank', NewBankId, 'required')}</p>
                        </Col>
                    </Form.Group>
                    {NewBankId!==37?
                            <Form.Group as={Row} className="mb-1 margintop-f" >
                                <Form.Label className="c-font" column sm={4}>
                                    *Branch
                                </Form.Label>
                                <Col sm={8}>
                                <Form.Select
                                value={JSON.stringify(SelectBranchAll)} 
                                onChange={SelectedBranch} size="sm" className="form-h2 ">
                                    <option value={JSON.stringify("select")}>Select</option>
                                    { BranchList.map((listValue,index)=>{
                                    return ( <option value={JSON.stringify(listValue)}>{listValue.name} - {listValue.code}</option>)
                                    })                            
                                    }                                    
                                </Form.Select>
                                
                                </Col>
                            </Form.Group>
                        :null}
                    <Form.Group as={Row} className="mb-1 " >
                        <Form.Label className="c-font" column sm={4}>
                          *Account Number
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Control 
                            value={NewPayeeAccountNum}
                            onBlur = {()=>{
                                if(NewBankId===37){
                                  CheckSenkadagalaAccounts();
                                }
                              }
                            }
                            onChange={(e)=>{setNewPayeeAccountNum(e.target.value)}}
                            className="form-h2" size="sm" 
                            type="number" placeholder="Account Number" />
                            <p className='vali-txt'>{validator2.message('Account Number', NewPayeeAccountNum, 'required')}</p>
                            {NewBankId===37&&SenkAccValidate?
                            <p className='vali-txt'>Incorrect Account Number</p>
                            :null}
                        </Col>
                    </Form.Group>
                    </div>
                    : ExistBankName?
                    <div className="block">
                    <Form.Group as={Row} className="mb-1  margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                           Name
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Label className="c-font" column>
                             {HolderName?HolderName:NewPayeeName}
                             </Form.Label>  
                        </Col>
                        <p className='vali-txt'>{validator2.message('Name', NewPayeeName, 'required')}</p>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1 margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                            Bank
                        </Form.Label>
                        <Col sm={8}>
                            <Form.Label className="c-font" column>
                                {ExistBankName?ExistBankName:NewPayeeSelectBank}
                            </Form.Label>                             
                        </Col>
                    </Form.Group>
                    {NewBankId!==37?
                        <Form.Group as={Row} className="mb-1 " >
                            <Form.Label className="c-font" column sm={4}>
                                Branch
                            </Form.Label>
                            <Col sm={8}>
                            <Form.Label className="c-font" column>
                            {ExistBranchName?ExistBranchName:NewPayeeSelectedBranch}
                            </Form.Label>                                
                            </Col>
                        </Form.Group>
                    :null}
                    
                    </div>:null
                    }
                    <Form.Group as={Row} className="mb-1 margintop-f">
                        <Form.Label className="c-font" column sm={4}>
                            *Amount
                        </Form.Label>
                        <Col sm={8} >

                        <Form.Control 
                        value={NewPayeeEnteredAmount}
                        onChange={(text)=>setNewPayeeEnteredAmount(text.target.value)}
                        className="form-h2" size="sm" type="number" placeholder="Amount" />
                         <p className='vali-txt'>{validator.message('Amount', NewPayeeEnteredAmount, 'required')}</p>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1 margintop-f">
                        <Form.Label className="c-font" column sm={4}>
                         Your Reference
                        </Form.Label>
                        <Col sm={8} >
                        <Form.Control
                        maxLength='14'
                        onBlur = {(e)=>{ExistYourRef?setExistBeneRef(e.target.value):setNewPayeeBeneRef(e.target.value)}}
                        value={ExistYourRef?ExistYourRef:NewPayeeYouRef}
                        onChange={(e)=> ExistYourRef?setExistYourRef(e.target.value):setNewPayeeYouRef(e.target.value)}
                         className="form-h2" size="sm"
                         type="email" placeholder="Your Reference" />

                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1 ">
                        <Form.Label className="c-font" column sm={4}>
                         Beneficiary Reference
                        </Form.Label>
                        <Col sm={8} >
                        <Form.Control 
                        className="form-h2" size="sm" 
                        onChange={(e)=>ExistBeneRef?setExistBeneRef(e.target.value):setNewPayeeBeneRef(e.target.value)}
                        value={ExistBeneRef?ExistBeneRef:NewPayeeBeneRef}
                        maxLength='14'
                        type="email" placeholder="Beneficiary Reference" /> 
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={4}>
                            *Payment Method
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select onChange={e=>setRecurring(e.target.value)} size="sm" className="form-h2 ">
                            <option value="">Select</option>
                            <option value="R">Set Up Recurring Transfer</option>
                            <option value="N">Set Up Recurring Transfer Until Further Notice</option>
                        </Form.Select>
                        <p className='vali-txt'>{validator.message('Payment Method', Recurring, 'required')}</p>
                        </Col>
                    </Form.Group>
                    {Recurring?
                    <Form.Group as={Row} className="mb-1 margintop-f3 s-bottoms">
                        <Form.Label className="c-font" column sm={4}>
                         *Payment Date
                        </Form.Label>
                        <Col sm={8} >
                            <div className='d-flex flex-row align-items-center'>                                
                              <DatePicker
                                  className="datepicker4  m-leftm "
                                  selected={StartDate}
                                  onChange={(e)=>setStartDate(e)}
                                  dateFormat="dd/MM/yyyy"
                                  minDate={new Date()}
                              />
                              <label className='lable l-width t-center'> To</label> 
                              {Recurring==="R"?
                                  <DatePicker
                                  className="datepicker4 m-rightm"
                                  selected={EndDate}
                                  onChange={(e)=>setEndDate(e)}
                                  dateFormat="dd/MM/yyyy"
                                  minDate={new Date()}
                              />:
                              Recurring==="N"?
                              <p className="p-line6">Until Further Notice</p>
                              :<p className="p-line6">-</p>
                                }
                            </div>                  
                        </Col>
                    </Form.Group>
                    :null
                    }
                    <Form.Group as={Row} className="mb-1 margintop-f3" >
                        <Form.Label className="c-font" column sm={4}>
                            *Frequency
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select
                        onChange={(value)=>setNewStandFrequency(value.target.value)} 
                        size="sm"
                         className="form-h2 ">
                          <option value="">Select</option>
                          <option value="M">Monthly</option>
                          <option value="D">Daily</option>
                          <option value="W">Weekly</option>
                          <option value="Q">Quarterly</option>
                          <option value="H">Half Yearly</option>
                          <option value="Y">Yearly</option>                                                
                        </Form.Select>
                        <p className='vali-txt'>{validator.message('Frequency', NewStandFrequency, 'required')}</p>
                        </Col>
                    </Form.Group>
                    <p className='vali-txt'>{ErrorMsg}</p>
                </Form>
              </Modal.Body>
              <Modal.Footer className="mb-1 margintop-f2">                
                <Button className="btn-logout" onClick={()=>ValidateFields()}>Process Transfer</Button>
              </Modal.Footer>
            </Modal>
          );
    }

export default StandingOrder;